import Theme from './Theme';

// AffiliateTheme étend le thème principal avec des styles spécifiques pour le portail affilié
const AffiliateTheme = {
  ...Theme, // Hérite de toutes les propriétés du thème principal
  
  // Remplacements et ajouts spécifiques pour les affiliés
  affiliate: {
    gradients: {
      // Gradient principal pour les éléments d'interface affilié (remplace les valeurs codées en dur)
      primary: `linear-gradient(135deg, ${Theme.colors.secondary} 0%, ${Theme.colors.primary} 100%)`,
      // Gradient secondaire pour les accents et boutons
      secondary: `linear-gradient(135deg, ${Theme.colors.primary} 0%, ${Theme.colors.accent} 100%)`,
      // Gradient pour les headers et footers (fond foncé)
      dark: `linear-gradient(135deg, #1A1A2E 0%, ${Theme.colors.secondary} 100%)`,
    },
    colors: {
      // Référence aux couleurs du thème principal pour une cohérence visuelle
      primary: Theme.colors.primary,      // #504099 (violet principal)
      secondary: Theme.colors.secondary,  // #313866 (bleu-violet foncé)
      accent: Theme.colors.accent,        // #9F73AB (violet clair)
      success: Theme.colors.success,      // #4CAF50 (vert)
      error: Theme.colors.error,          // #F44336 (rouge)
      warning: Theme.colors.warning,      // #FF9800 (orange)
      
      // Couleurs spécifiques pour l'interface affilié
      background: '#f8f9fa',              // Couleur de fond légère pour les pages
      card: '#FFFFFF',                    // Couleur de fond pour les cartes et formulaires
      cardAlt: '#F4F5F7',                 // Couleur alternative pour les cartes
      border: '#E6E8EB',                  // Couleur de bordure standard
      
      // Couleurs de texte
      text: {
        primary: '#333333',               // Texte principal (presque noir)
        secondary: '#666666',             // Texte secondaire (gris foncé)
        light: '#FFFFFF',                 // Texte clair (pour fond foncé)
        disabled: '#999999',              // Texte désactivé
        accent: Theme.colors.primary,     // Texte accentué (utilise la couleur primaire)
        contrast: {
          primary: '#FFFFFF',             // Contraste pour couleur primaire
          secondary: '#FFFFFF',           // Contraste pour couleur secondaire
          accent: '#FFFFFF',              // Contraste pour couleur accent
          dark: '#FFFFFF',                // Contraste pour fond foncé
          light: '#333333',               // Contraste pour fond clair
        }
      }
    },
    
    // Styles spécifiques pour le portail affilié
    cardShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    animationDuration: '0.3s',
    
    // Styles responsive
    breakpoints: Theme.breakpoints,
    
    // Styles des états
    states: {
      hover: {
        opacity: 0.85,
        transform: 'translateY(-2px)',
      },
      active: {
        opacity: 0.7,
      },
      disabled: {
        opacity: 0.5,
        pointerEvents: 'none',
      }
    }
  }
};

export default AffiliateTheme;